import { isNumber } from "lodash"
import { formatCurrency } from "helpers/formatters/numbers"

interface PositionRowProps {
  label: string
  currency: string | undefined
  economicExposure: number
}

export default function PositionRow({ label, economicExposure, currency }: PositionRowProps) {
  return (
    <div className="tooltip-row">
      <span>{label}</span>
      {isNumber(economicExposure) && <span>{formatCurrency(economicExposure, currency, {})}</span>}
    </div>
  )
}
